module.exports = __webpack_public_path__ + "img/icon-wine-freezer.40d0b097.svg";